import type { Address } from 'viem'

import type { HistoryRange } from '@/lib/transforms/history/window'

import { orpc } from '@/lib/orpc/client'

/** Above 0, so the range the server prefetched is not refetched as soon as the page hydrates. */
const TOTAL_ASSETS_HISTORY_STALE_TIME_MS = 5 * 60_000

/** One set of options for the server prefetch and the client read, so their keys match. */
export function totalAssetsHistoryQueryOptions(input: {
  chainId: number
  address: Address
  range: HistoryRange
}) {
  return orpc.vaultV2.totalAssetsHistory.queryOptions({
    input,
    staleTime: TOTAL_ASSETS_HISTORY_STALE_TIME_MS
  })
}
